import Rules from "./rules.hbd"
export default Rules
